import React, { FC } from "react";
import { Box, CircularProgress } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useQuery } from "@apollo/client";
import {
  Offers,
  OffersVariables,
} from "../../graphql/onboarding/offer/types/Offers";
import { DISPLAY_OFFER, OFFERS } from "../../graphql/onboarding/offer/query";
import { ONBOARDING } from "../../graphql/onboarding/onboarding/query";
import { OnboardingInfo } from "../../graphql/onboarding/onboarding/types/OnboardingInfo";
import { DisplayOffer } from "../../graphql/onboarding/offer/types/DisplayOffer";
import { getConfigOffer, getPreselectedOffer } from "./logic";
import Offer from "./Offer";
import {
  CheckPaymentStripe,
  CheckPaymentStripeVariables,
} from "../../graphql/onboarding/stripe/types/CheckPaymentStripe";
import { CHECK_PAYMENT_STRIPE } from "../../graphql/onboarding/stripe/query";
import { Payment_Status } from "../../enums/stripe";
import { useNavigate } from "react-router-dom";

interface SelectOfferProps {
  create?: boolean;
}

const SelectOffer: FC<SelectOfferProps> = ({ create }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { data: offersData, loading: offerLoading } = useQuery<
    Offers,
    OffersVariables
  >(OFFERS, { variables: { isPackage: create } });
  const { data: onboarding, loading } = useQuery<OnboardingInfo>(ONBOARDING, {
    fetchPolicy: "no-cache",
  });

  const { data: config, loading: loadingConfig } = useQuery<DisplayOffer>(
    DISPLAY_OFFER,
    {
      fetchPolicy: "no-cache",
    },
  );

  const { loading: checkStripeLoading } = useQuery<
    CheckPaymentStripe,
    CheckPaymentStripeVariables
  >(CHECK_PAYMENT_STRIPE, {
    variables: { changeStep: false },
    onCompleted: ({ checkPaymentStripe }) => {
      if (checkPaymentStripe === Payment_Status.PAID) {
        navigate("/company");
      }
    },
  });

  if (loading || offerLoading || loadingConfig || checkStripeLoading) {
    return (
      <Box position="absolute" top="50%" left="50%">
        <CircularProgress />
      </Box>
    );
  }

  const configOffer = getConfigOffer(config?.displayOffer || [], intl);
  const offer = onboarding?.onboardingInfo?.offer;
  const offers = offersData?.offers ?? [];
  const offerDefault =
    offer && offers.some((o) => o?.id === offer.id)
      ? offer
      : getPreselectedOffer(offers);

  return (
    <Offer
      config={configOffer}
      offerDefault={offerDefault}
      offers={offers}
      accepted={!!onboarding?.onboardingInfo?.offer}
      create={create}
    />
  );
};
export default SelectOffer;
